import React, { useState } from 'react';
import { register } from '../services/api';

const Register = ({ setToken }) => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    email: '',
    role: 'student',
    department: 'general',
    secret_key: '',
    first_name: '',
    last_name: '',
    second_name: '',
    admission_no: '',
    class_stream: '',
    next_of_kin_phone_number: '',
    relationship: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await register(formData);
    if (response.token) {
      setToken(response.token);
    } else {
      alert(response.message || "Registration failed.");
    }
  };

  const role = formData.role;

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Thogoto T.T.C Registration</h2>
        <form onSubmit={handleSubmit} style={styles.form}>
          {/* Common Fields */}
          <div style={styles.formGroup}>
            <label style={styles.label}>Username</label>
            <input 
              type="text" name="username" placeholder="Enter your username" 
              onChange={handleChange} required style={styles.input} 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input 
              type="password" name="password" placeholder="Enter your password" 
              onChange={handleChange} required style={styles.input} 
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Email</label>
            <input 
              type="email" name="email" placeholder="Enter your email" 
              onChange={handleChange} required style={styles.input} 
            />
          </div>

          <div style={styles.formRow}>
            <div style={styles.formGroup}>
              <label style={styles.label}>Role</label>
              <select name="role" onChange={handleChange} style={styles.select}>
                <option value="student">Student</option>
                <option value="professor">Teacher</option>
                <option value="admin">Admin</option>
              </select>
            </div>

            <div style={styles.formGroup}>
              <label style={styles.label}>Department/Course</label>
              <input 
                type="text" name="department" placeholder="Department" 
                onChange={handleChange} required style={styles.input} 
              />
            </div>
          </div>

          {/* Secret Key Field for Admin/Professor */}
          {(role === 'admin' || role === 'professor') && (
            <div style={styles.formGroup}>
              <label style={styles.label}>Secret Key</label>
              <input 
                type="text" name="secret_key" placeholder="Enter secret key" 
                onChange={handleChange} required style={styles.input} 
              />
            </div>
          )}

          {/* First & Last Name (for all roles) */}
          {(role === 'student' || role === 'professor' || role === 'admin') && (
            <>
              <div style={styles.formGroup}>
                <label style={styles.label}>First Name</label>
                <input 
                  type="text" name="first_name" placeholder="First Name" 
                  onChange={handleChange} required style={styles.input} 
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Last Name</label>
                <input 
                  type="text" name="last_name" placeholder="Last Name" 
                  onChange={handleChange} required style={styles.input} 
                />
              </div>
            </>
          )}

          {/* Student-only Fields */}
          {role === 'student' && (
            <>
              <div style={styles.formGroup}>
                <label style={styles.label}>Second Name</label>
                <input 
                  type="text" name="second_name" placeholder="Second Name" 
                  onChange={handleChange} required style={styles.input} 
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Admission Number</label>
                <input 
                  type="text" name="admission_no" placeholder="Admission No" 
                  onChange={handleChange} required style={styles.input} 
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Class Stream</label>
                <input 
                  type="text" name="class_stream" placeholder="Class Stream" 
                  onChange={handleChange} required style={styles.input} 
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Next of Kin Phone Number</label>
                <input 
                  type="text" name="next_of_kin_phone_number" placeholder="Next of Kin Phone" 
                  onChange={handleChange} required style={styles.input} 
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Relationship</label>
                <input 
                  type="text" name="relationship" placeholder="Relationship" 
                  onChange={handleChange} required style={styles.input} 
                />
              </div>
            </>
          )}

          <button type="submit" style={styles.button}>Register</button>
        </form>
        <p style={styles.footerText}>
          Already have an account? <a href="/login" style={styles.link}>Login here</a>
        </p>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '80vh',
    backgroundColor: '#f8f8f8',
    fontFamily: "'Georgia', serif",
  },
  card: {
    backgroundColor: '#fff',
    padding: '2.5rem',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
    width: '100%',
    maxWidth: '600px',
    borderTop: '4px solid #A51C30',
  },
  title: {
    color: '#A51C30',
    textAlign: 'center',
    marginBottom: '2rem',
    fontSize: '1.8rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  formRow: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '1.5rem',
  },
  formGroup: {
    flex: 1,
    marginBottom: '1.5rem',
  },
  label: {
    display: 'block',
    marginBottom: '0.5rem',
    color: '#333',
    fontSize: '1rem',
  },
  input: {
    width: '100%',
    padding: '0.75rem',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
  },
  select: {
    width: '100%',
    padding: '0.75rem',
    border: '1px solid #ddd',
    borderRadius: '4px',
    fontSize: '1rem',
    backgroundColor: '#fff',
  },
  button: {
    backgroundColor: '#A51C30',
    color: '#fff',
    padding: '0.75rem',
    border: 'none',
    borderRadius: '4px',
    fontSize: '1rem',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    marginTop: '1rem',
  },
  footerText: {
    textAlign: 'center',
    marginTop: '1.5rem',
    color: '#666',
  },
  link: {
    color: '#A51C30',
    textDecoration: 'none',
  },
};

export default Register;
